class SubNavigationMenu {
    constructor() {
        const container = document.querySelector('.sub-navigation-menu-mobile');

        if (!container)
            return;

        const toggler = container.querySelector('.sub-navigation-menu-mobile__toggler');
        const icon = container.querySelector('.sub-navigation-menu-mobile__arrow');
        const list = container.querySelector('.sub-navigation-menu-mobile__list');
        const overlay = document.querySelector('.sub-navigation-menu-mobile-overlay');
        const mobileLinks = container.querySelectorAll('.sub-navigation-menu-mobile__link');

        const closeMenu = () => {
            container.classList.remove('sub-navigation-menu-mobile--open');
            toggler.setAttribute('aria-expanded', false);
            list.setAttribute('aria-hidden', true);
            icon.classList.replace('fa-close', 'fa-chevron-down');
        };

        if (container && toggler && icon && list) {
            toggler.addEventListener('click', () => {
                if (container.classList.contains('sub-navigation-menu-mobile--open')) {
                    closeMenu();
                } else {
                    container.classList.add('sub-navigation-menu-mobile--open');
                    toggler.setAttribute('aria-expanded', true);
                    list.setAttribute('aria-hidden', false);
                    icon.classList.replace('fa-chevron-down', 'fa-close');
                }
            });
        }

        if (overlay) {
            overlay.addEventListener('click', closeMenu);
        }

        if (mobileLinks) {
            mobileLinks.forEach(link => {
                link.addEventListener('click', closeMenu);
            });
        }
    }
}

document.addEventListener("DOMContentLoaded", () => new SubNavigationMenu());
